/* eslint-disable no-irregular-whitespace */
import CoreFeature1 from "../assets/images/coreFeature1.svg";
import CoreFeature2 from "../assets/images/coreFeature2.svg";
import CoreFeature3 from "../assets/images/coreFeature3.svg";
import CoreFeature4 from "../assets/images/coreFeature4.svg";
import CoreFeature5 from "../assets/images/coreFeature5.svg";
import CoreFeature6 from "../assets/images/coreFeature6.svg";
import Industry from "../assets/images/industry.png";
import Logistic from "../assets/images/logistic.png";
import Hotels from "../assets/images/hotel.png";
import Media from "../assets/images/media.png";
import Food from "../assets/images/food.png";
import Restate from "../assets/images/restate.png";
import Ai from "../assets/images/ai.png";
import Energy from "../assets/images/energy.png";
import Telcom from "../assets/images/telcom.png";
import Travel from "../assets/images/travel.png";
import Tech from "../assets/images/tech.png";
import Pharma from "../assets/images/pharma.png";

export const translation = {
  English: {
    termsDesc: `Last Updated: 15/08/2024
Welcome to AndaiHub. These Terms and Conditions govern your use of our website and services. By accessing or using our platform, you agree to these terms. Please read them carefully.

1. Introduction
These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("User" or "you") and AndaiHub ("Company," "we," "us," or "our"). By accessing our services, you accept these Terms in full. If you disagree with any part of these Terms, please do not use our services.

2. Eligibility
By using AndaiHub, you represent that you are at least 18 years old and have the legal capacity to enter into this agreement. Users under the age of 18 must obtain parental consent.

3. Services Provided
AndaiHub offers a marketplace for AI plugins and custom AI solutions tailored to specific use cases. Our services include, but are not limited to, plugin access, customization, API integration, and consultation.

4. User Accounts
To access certain features, you must create an account. You agree to provide accurate and current information during registration. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.

5. Subscription Plans and Payment
AndaiHub offers multiple subscription plans with varying features. By selecting a plan, you agree to pay the fees associated with that plan. All payments are non-refundable unless stated otherwise. We reserve the right to modify pricing at any time but will notify users in advance.

6. Intellectual Property Rights
All content, software, and intellectual property available through AndaiHub are owned by us or our licensors. You are granted a limited, non-exclusive, and revocable license to use our services for your personal or business needs, subject to these Terms.

7. User Content and Conduct
You may be able to post, upload, or share content through AndaiHub. You retain ownership of your content but grant us a license to use, display, and distribute it as needed to operate our services. You agree not to engage in any unlawful, harmful, or abusive activities that may harm the integrity of our platform.

8. Privacy
Our Privacy Policy governs the collection, use, and storage of personal data. By using our services, you consent to the collection and use of information in accordance with our Privacy Policy.

9. Termination
We reserve the right to suspend or terminate your access to AndaiHub without notice if you breach these Terms or engage in activities that are harmful, unlawful, or in violation of our policies.

10. Limitation of Liability
To the fullest extent permitted by law, AndaiHub and its affiliates shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services. Our liability in all cases is limited to the amount you paid to us.

11. Indemnification
You agree to indemnify and hold harmless AndaiHub, its employees, and affiliates from any claims, liabilities, damages, losses, or expenses arising out of your use of our services or breach of these Terms.

12. Governing Law and Dispute Resolution
These Terms shall be governed by and construed in accordance with the laws of Respective LGeographical Location. Any disputes arising out of these Terms shall be resolved through binding arbitration in respective location, unless otherwise required by law.

13. Changes to Terms
We reserve the right to modify these Terms at any time. Any changes will be posted on this page with the updated date. Continued use of our services after modifications signifies your acceptance of the revised Terms.

14. Contact Information
If you have any questions or concerns about these Terms, please contact us at:

Email: andai@andai.co.in
Address 1: Startspace, VIC, Melbourne
Address 2: ANDAI PLATFORMS PRIVATE LIMITED
648 5 INDUSTRIES AREA, RAJSHAHI, RAU, Rao, Mhow, Indore- 453331, Madhya Pradesh`,

    termsText: "Terms and Condition",
    refundText: "Refund Policy",
    refuncDesc: `Last Updated: 15/08/2024
Once the refund request is approved,The Refunded Amount will be processed and credited within 10 to 12 business days to the original mode of payment.
Email: andai@andai.co.in
Address 1: Startspace, VIC, Melbourne
Address 2: ANDAI PLATFORMS PRIVATE LIMITED
648 5 INDUSTRIES AREA, RAJSHAHI, RAU, Rao, Mhow, Indore- 453331, Madhya Pradesh`,

    pricing: "Pricing",
    aboutUs: "About us",
    signUp: "Sign up",
    blog: "Blog",
    career: "Career",
    andaihub: "Andaihub",
    thisisfinal: "This is a final call to action",
    getAiReady: "Get AI ready in minutes",
    getWhat: "Get what you need at the price that you want!",
    signUpToday: "Sign up today",
    getAiReadyText: "Get AI ready",
    aiPlugins: "AI Plugins",
    customTailored: "Custom Tailored",
    solveWhat: "Solve what matters",
    aiMarket: "AI Marketplace",
    contactUs: "Contact us",
    copyRight: "© Copyright. All rights reserved by",
    appl: "And Ai Platforms Private Limited",
    Product: "Product",
    signup: "Signup",
    resources: "Resources",
    company: "Company",
    aboutUsCamel: "About Us",
    info: "Info",
    privacyPolicy: "Privacy Policy",
    refundPolicy: "Refund Policy",
    termAndCons: "Terms & Condition",
    freeMonths: "Free(3 months)",
    inrText: "INR",
    moText: "mo",
    freeDetail: ["1 AI Plugin", "2 users", "Email support"],
    startMsme: "Startup / MSME",
    startUpDetail: [
      "10 AI Plugins",
      "10 users",
      "In-app and email support",
      "Data Security",
      "Integrations",
      "Extra features",
    ],
    frequentlyQue: "Frequently asked questions",
    enterPrise: "Enterprise",
    custom: "Custom",
    enterPriseDetail: [
      "Dedicated support",
      "Enterprise SSO",
      "Custom security",
    ],
    compareFeatures: "COMPARE FEATURES",
    compareFeatureHeader: [
      "Compare features",
      "Free",
      "Startups",
      "Enterprise",
    ],
    compareFeatureBox: [
      { feature: "AI Plugin", free: true, startups: true, enterprise: true },
      {
        feature: "AI magic link (integration)",
        free: true,
        startups: true,
        enterprise: true,
      },
      {
        feature: "Custom LLM Integration workflow",
        free: true,
        startups: true,
        enterprise: true,
      },
      {
        feature: "Customised AI Plugins",
        free: false,
        startups: true,
        enterprise: true,
      },
      {
        feature: "RAG/AI Agent/AI Storage (1 Collection)",
        free: false,
        startups: true,
        enterprise: true,
      },
      {
        feature: "Live AI Chat Support, AI Audio bot & Human in loop",
        free: false,
        startups: true,
        enterprise: true,
      },
      {
        feature: "AI Workflow(1), AI Custom Trained Plugins(2)",
        free: false,
        startups: true,
        enterprise: true,
      },
      {
        feature: "AI Platform Access",
        free: false,
        startups: false,
        enterprise: true,
      },
      {
        feature: "Unlimited AI Video/Voice Calls",
        free: false,
        startups: false,
        enterprise: true,
      },
      {
        feature: "Custom AI Agents, Funnels, Workflows",
        free: false,
        startups: false,
        enterprise: true,
      },
      {
        feature: "On Premise Solution",
        free: false,
        startups: false,
        enterprise: true,
      },
      {
        feature: "Security & AI Governance",
        free: false,
        startups: false,
        enterprise: true,
      },
    ],
    coreFeatures: "Core features",
    hiringArray: [
      {
        question: "Full-stack Engineer",
        answer:
          "We are always in the dire need of great developers, If you think you are a good fit let us know.",
      },
      {
        question: "Product Designer",
        answer:
          "If you are an individual who wants to work along AI product offering, come join our team!",
      },
    ],
    faqArray: [
      {
        question: "Can I cancel at any time?",
        answer:
          "Yes, But there is a MOU and NDA signed if you are part of Andaihub (Learn & Develop), which states that you cant discontinue the subscription.",
      },
      {
        question: "Can I export my data?",
        answer:
          "Yes, your data is your property, mostly if you go with our cloud plan, we suggest you to have a data privacy signed prior to execution.",
      },
      {
        question: "How do I downgrade or upgrade my plan?",
        answer: "By having a call with us or you can drop us a mail",
      },
      {
        question: "What payment methods do you offer?",
        answer: "We accept payments with all available methods",
      },
      {
        question: "Do you offer a free trial?",
        answer:
          "Yes, we shall offer you 1 free AI plugin, post which we would love to have you onboarded in our andaihub family.",
      },
    ],
    coreFeaturesArray: [
      {
        head: "AI Plugin Curation and Recommendation Engine",
        desc: "Our advanced algorithm analyzes your business needs and recommends the most suitable AI plugins from our marketplace. This ensures you find the perfect AI solution tailored to your unique requirements, saving time and maximizing the impact of AI integration.",
        image: CoreFeature1,
      },
      {
        head: "Custom Integration Services",
        desc: "Our team of experts provides end-to-end support for seamlessly integrating selected AI plugins into your existing business processes and systems. We handle the technical complexities, allowing you to focus on leveraging AI to drive growth and innovation.",
        image: CoreFeature2,
      },
      {
        head: "Vendor Showcase Platform",
        desc: "AI providers can showcase their offerings to businesses seeking AI solutions. Our platform offers tools for product demonstration, lead management, and client connection. This feature fosters a dynamic marketplace that benefits both vendors and clients seeking cutting-edge AI technologies.",
        image: CoreFeature3,
      },
      {
        head: "Business Domain Analysis",
        desc: "Our industry experts conduct in-depth analyses of your business domain, identifying key areas where AI can make the most significant impact. This ensures our AI plugin recommendations are not just technologically advanced but also strategically aligned with your specific business goals and challenges.",
        image: CoreFeature4,
      },
      {
        head: "Customizable AI Solution Packages",
        desc: "We offer custom-tailored AI solution packages that combine multiple plugins and services to address complex business challenges. These packages can be fine-tuned to meet your specific needs, providing a comprehensive and adaptable AI strategy for your organization's unique requirements.",
        image: CoreFeature5,
      },
      {
        head: "AndAIHub Proprietary Plugins",
        desc: "Access our suite of in-house developed AI plugins, designed to fill market gaps and offer unique capabilities. These proprietary solutions complement our curated selection, ensuring a comprehensive AI toolkit that addresses a wide range of business needs with innovative, exclusive technologies.",
        image: CoreFeature6,
      },
    ],
    andaihubDest: "Andaihub Your AI Destination",
    verticals: "Verticals",
    ourClients: "Our Clients",
    ourPartners: "Our Partners",
    supportPartners: "Support Partners",
    weAreHiring: "We're hiring",
    chatWithUs: "Chat with Us",
    infoText: "Info",
    infoDesc: `AndAI Platforms Private Limited 
    648 5 INDUSTRIES AREA, RAJSHAHI, RAU, Rao, Mhow, Indore- 453331, Madhya Pradesh
    CIN - U58200MP2024PTC072999
    Contact - +91 84 84 84 1871
    Email - contact@andai.co.in`,
    privacyText: "Privacy Policy",
    privacyDesc: `Last Updated: 15/08/2024

1. Introduction
Welcome to AndaiHub. Your privacy is of utmost importance to us, and we are committed to protecting it. This Privacy Policy outlines how we collect, use, share, and safeguard your information when you interact with our services, including through our website, AI plugins, and related services. By using our services, you agree to the practices described in this policy.

2. Information We Collect
We collect various types of information, including:
Personal Information: When you sign up, make inquiries, or use our services, we may collect information such as your name, email address, phone number, company details, and other contact information.
Technical Data: This includes IP addresses, browser type, operating system, device information, and usage data (e.g., pages visited, time spent, and interactions) to enhance your experience and monitor usage.
Communications: Any communications you send to us, such as customer support inquiries or feedback, may be stored and reviewed to improve our services.

3. How We Use Your Information
We use your information for a variety of purposes, including but not limited to:
Service Provision: To deliver, manage, and improve our AI plugins and tailored solutions.
Customer Support: To provide assistance and resolve issues.
Marketing and Updates: To inform you about new features, products, services, and promotional offers (with your consent).
Personalization: To tailor our offerings based on your preferences and previous interactions.
Analytics: To analyze trends and improve our products, services, and overall user experience.

4. Data Sharing and Third-Party Disclosure
We value your privacy and do not sell or rent your personal information. We only share your data under the following conditions:
Service Providers: We work with trusted third-party partners (e.g., payment processors, analytics providers, hosting services) who process data on our behalf. These partners adhere to strict confidentiality agreements.
Legal Compliance: We may disclose your information to comply with legal obligations, enforce our terms of service, or protect the rights, property, or safety of AndaiHub, our users, or others.

5. Data Security
We employ industry-standard security measures, including encryption and secure data storage, to protect your information from unauthorized access, alteration, disclosure, or destruction. While we strive to protect your data, no system is completely secure. We recommend that you take your own precautions by using strong passwords and safeguarding your account.

6. Cookies and Tracking Technologies
Our website uses cookies and similar technologies to enhance user experience, provide personalized content, and analyze traffic. You can manage your cookie preferences through your browser settings. Disabling cookies may affect your ability to use certain features of our website.

7. Your Rights and Choices
You have the following rights regarding your personal data:
Access: Request access to the personal information we hold about you.
Correction: Request corrections to inaccurate or incomplete data.
Deletion: Request the deletion of your data under certain conditions.
Opt-Out: Unsubscribe from marketing communications at any time.
To exercise these rights, please contact us at privacy@andaihub.com. We will respond to your request within a reasonable timeframe.

8. International Data Transfers
As a global service, your data may be transferred to and processed in countries other than your own. We ensure that any such transfers comply with applicable data protection laws.

9. Retention of Data
We retain your personal information for as long as necessary to fulfill the purposes outlined in this policy, or as required by law. When your data is no longer needed, we securely delete or anonymize it.

10. Children’s Privacy
Our services are not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take immediate steps to delete it.

11. Updates to This Privacy Policy
We may update this policy from time to time. Any changes will be posted on this page with the updated date. We encourage you to review this policy periodically to stay informed about how we are protecting your information.

12. Contact Us
If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at:

Email: andai@andai.co.in
Address 1: Startspace, VIC, Melbourne
Address 2: ANDAI PLATFORMS PRIVATE LIMITED
648 5 INDUSTRIES AREA, RAJSHAHI, RAU, Rao, Mhow, Indore- 453331, Madhya Pradesh`,
    verticalArray: [
      { head: "Industry", subHead: "Ai Plugins & Platforms", image: Industry },
      { head: "Logistic", subHead: "Ai Plugins & Platforms", image: Logistic },
      { head: "Media", subHead: "Ai Plugins & Platforms", image: Media },
      { head: "Hotels", subHead: "Ai Plugins & Platforms", image: Hotels },
      { head: "Food", subHead: "Ai Plugins & Platforms", image: Food },
      { head: "Restate", subHead: "Ai Plugins & Platforms", image: Restate },
      { head: "AI", subHead: "Ai Plugins & Platforms", image: Ai },
      { head: "Energy", subHead: "Ai Plugins & Platforms", image: Energy },
      { head: "Telcom", subHead: "Ai Plugins & Platforms", image: Telcom },
      { head: "Travel", subHead: "Ai Plugins & Platforms", image: Travel },
      { head: "Tech", subHead: "Ai Plugins & Platforms", image: Tech },
      { head: "Pharma", subHead: "Ai Plugins & Platforms", image: Pharma },
    ],
  },
};
